import { render, staticRenderFns } from "./QuestionEditDialog.vue?vue&type=template&id=3b8370bc&scoped=true"
import script from "./QuestionEditDialog.vue?vue&type=script&lang=js"
export * from "./QuestionEditDialog.vue?vue&type=script&lang=js"
import style0 from "./QuestionEditDialog.vue?vue&type=style&index=0&id=3b8370bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8370bc",
  null
  
)

export default component.exports